import React, { useState } from 'react';

import { DeleteOutlined } from '@ant-design/icons';
import { Button, Flex, Modal } from 'antd';
import { toast } from 'react-toastify';
import { Partner } from 'src/interfaces/entities/partners';
import { useDeletePartnerMutation } from 'src/redux/services/centralApi';

export default function DeletePartner(
	{
		row,
	}: { row: Partner }
) {
	const [ open, setOpen, ] = useState<boolean>(false);

	const [ deletePartner, deletePartnerResult, ] = useDeletePartnerMutation();

	return <>
		<Button
			type="text"
			danger
			icon={<DeleteOutlined />}
			onClick={() => setOpen(true)}
		/>
		<Modal
			centered
			title={'Excluir Parceiro'}
			open={open}
			onCancel={() => {
				setOpen(false);
				toast.info('Operação cancelada!', { autoClose: 1000, });
			}}
			destroyOnHidden
			okText="Excluir"
			onOk={() => {
				deletePartner(row.id)
					.unwrap()
					.then(() => {
						toast.success('Parceiro excluído com sucesso!', {
							autoClose: 1000,
						});
					})
					.catch((err) => {
						if (err?.status && err?.status === 500
							&& err?.data?.frontend_message) {
							toast.error(err?.data?.frontend_message, {
								autoClose: 1000,
							});
						}
					})
					.finally(() => {
						setOpen(false);
					});
			}}
			confirmLoading={deletePartnerResult.isLoading}
		>
			<Flex>
				{`Tem certeza que deseja deletar o parceiro: ${row.name}`}
			</Flex>
		</Modal>
	</>;
}